// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_Dtd","cls2":"OnboardingTour-cls2_lkY OnboardingTour-cls1_Dtd"};